/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/ranking";

export function getAll(values) {
  return APIClient.post(`/Order${endpoint}/manager`, values);
}
